import { Practitioner } from "./../../open-age/telepain/models/practitioner";
import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { UxService } from "~/app/core/services/ux.service";
import { RoleService } from "~/app/open-age/core/services";
import { NavService } from "~/app/core/services";
import { ActivatedRoute } from "@angular/router";
import { Link } from "~/app/open-age/core/structures";
import { MatDatepicker, MatDialog } from "@angular/material";
import { AddPatientsDialogComponent } from "../components/add-patients-dialog/add-patients-dialog.component";
import { Patient } from "./../../open-age/telepain/models/patient";
import { Appointment } from '~/app/open-age/welcome/models/appointment.model';
import * as moment from 'moment';
import { User } from '~/app/open-age/welcome/models/user.model';
import { AppointmentsService, AppointmentTypeService, AvailabilityService } from '~/app/open-age/welcome/services';
import { QuickAddPatientsDialogComponent } from '../components/quick-add-patients-dialog/quick-add-patients-dialog.component';
import { AppointmentType, AvailableDate, AvailableTime } from "~/app/open-age/welcome/models/appointment-type.model";
import { OrganizationService as WelcomeOrganizationService } from "~/app/open-age/welcome/services";
import { OrganizationService } from "~/app/open-age/directory/services";
import { Organization as DirecotyOrganization } from "~/app/open-age/directory/models";
import { Calendar, Category } from "~/app/open-age/welcome/models/calendar.model";
import { Organization } from "~/app/open-age/welcome/models/organization.model";

@Component({
  selector: "app-appointment-new",
  templateUrl: "./appointment-new.component.html",
  styleUrls: ["./appointment-new.component.css"],
})
export class AppointmentNewComponent implements OnInit {
  appointment: Appointment = new Appointment({});
  calendarID: string
  isProcessing: boolean;
  displayedColumns: string[] = [
    "name",
    "practice",
    "location",
    "prescriber",
    "action",
  ];
  minDate: Date;
  isCurrent = true;
  page: Link;
  appointmentTypes: AppointmentType[] = []
  date: Date
  availableDates: AvailableDate[]
  availableTimes: AvailableTime[] = []
  selectedTime: AvailableTime
  provider: {
    user: User,
    calendars: {
      category: Category,
      calendar: Calendar,
      isActive: Boolean
    }[],
    grouped?: any
  };
  availableSlots = 1
  providers: {
    user: User,
    calendars: {
      category: Category,
      calendar: Calendar,
      isActive: Boolean
    }[],
    grouped?: any
  }[] = [];

  category: Category;
  categories: Category[] = [];

  practice: Organization
  practices: DirecotyOrganization[] = []

  showSearchContainer: boolean = false;

  @ViewChild("userInput")
  patientInput: ElementRef<HTMLInputElement>;

  @ViewChild("table") table;
  userInput: ElementRef<HTMLInputElement>;

  startTime: string;
  endTime: string;

  @ViewChild('picker') calendar: MatDatepicker<any>;

  timeZones = ["Asia/Calcutta", "America/Los_Angeles"]
  timeZone: string

  constructor(
    public dialog: MatDialog,
    private auth: RoleService,
    private errorHandler: UxService,
    private navService: NavService,
    private route: ActivatedRoute,
    private appointmentService: AppointmentsService,
    private appointmentTypeService: AppointmentTypeService,
    private availabilityService: AvailabilityService,
    private organizationService: OrganizationService,
    private welcomeOrganizationService: WelcomeOrganizationService
  ) {
    let exist = false
    for (const item of this.timeZones) {
      if (item == moment.tz.guess()) {
        exist = true
        this.timeZone = item
      }
    }
    if (!exist) {
      this.timeZones.push(moment.tz.guess())
      this.timeZone = this.timeZones[this.timeZones.length - 1]
    }
    this.isProcessing = true
    this.organizationService.search().subscribe(page => {
      this.practices = page.items
      this.isProcessing = false
    }, err => {
      this.isProcessing = false
    })
  }

  ngOnInit() {
    this.page = this.navService.register(
      `/appointment/list/new`,
      this.route,
      (isCurrent, params) => {
        this.isCurrent = isCurrent;
        if (this.isCurrent) {
          this.setContext();
        }
      }
    );
    this.minDate = moment().subtract(1, 'day').toDate()
  }

  add() {
    if (!this.practice) {
      this.errorHandler.handleError("Appointment Practice is required");
      return;
    }
    if (!this.provider) {
      this.errorHandler.handleError("Provider is required");
      return;
    }
    if (!this.appointment.appointmentType) {
      this.errorHandler.handleError("Appointment Type is required");
      return;
    }
    if (!this.date) {
      this.errorHandler.handleError("Appointment Date is required");
      return;
    }
    if (!this.selectedTime) {
      this.errorHandler.handleError("Appointment Time is required");
      return;
    }
    if (!this.appointment.visitors || !this.appointment.visitors.length) {
      this.errorHandler.handleError("Quick Add Patient is required to create Appointment");
      return;
    }
    let calendarData = this.getCalendar(this.provider, this.selectedTime.calendarID)
    if (!calendarData) {
      this.errorHandler.handleError("Error: Unable to Create Appointment");
      return;
    }
    this.appointment.organizations = [this.practice]
    this.appointment.agent = this.provider.user
    this.appointment.calendar = calendarData.calendar
    this.appointment.category = calendarData.category
    this.isProcessing = true;
    this.appointmentService.create(this.appointment).subscribe(() => {
      this.isProcessing = false;
      this.errorHandler.showInfo("Appointment Created Successfully");
      this.back();
    }, err => this.isProcessing = false)
  }

  setContext() { }

  back() {
    this.navService.goto("/appointment/list");
  }

  onPracticeSelected() {
    this.isProcessing = true
    this.availableDates = null
    this.selectedTime = null
    this.date = null
    this.availableTimes = []
    this.availableSlots = 1
    this.appointment.visitors = []
    this.appointment.appointmentType = null
    this.welcomeOrganizationService.get(this.practice.code).subscribe(item => {
      this.practice.users = item.users
      this.providers = item.users
      this.getCategories()
      this.isProcessing = false
    }, err => {
      this.isProcessing = false
    })
  }

  onSelectedType() {
    this.selectedTime = null
    this.date = null
    this.availableTimes = []
    this.availableSlots = 1
    this.appointment.visitors = []
    this.availableDates = null
    this.getDates()
  }

  getDates() {
    this.isProcessing = true
    this.availabilityService.dates.search({
      appointmentTypeID: this.appointment.appointmentType.acuityId,
      month: moment().format("YYYY-MM"),
      organization: this.practice.code,
      user: this.provider.user.id,
      category: this.category ? this.category.id : '',
      timeZone: this.timeZone
    }).subscribe(page => {
      if (!this.availableDates) {
        this.availableDates = []
      }
      for (const item of page.items) {
        this.availableDates.push(new AvailableDate(item))
      }
      this.isProcessing = false
    }, err => {
      this.isProcessing = false
    })
    this.availabilityService.dates.search({
      appointmentTypeID: this.appointment.appointmentType.acuityId,
      month: moment().add(1, 'month').format("YYYY-MM"),
      organization: this.practice.code,
      user: this.provider.user.id,
      category: this.category ? this.category.id : '',
      timeZone: this.timeZone
    }).subscribe(page => {
      if (!this.availableDates) {
        this.availableDates = []
      }
      for (const item of page.items) {
        this.availableDates.push(new AvailableDate(item))
      }
    })
    this.availabilityService.dates.search({
      appointmentTypeID: this.appointment.appointmentType.acuityId,
      month: moment().add(2, 'month').format("YYYY-MM"),
      organization: this.practice.code,
      user: this.provider.user.id,
      category: this.category ? this.category.id : '',
      timeZone: this.timeZone
    }).subscribe(page => {
      if (!this.availableDates) {
        this.availableDates = []
      }
      for (const item of page.items) {
        this.availableDates.push(new AvailableDate(item))
      }
    })
    this.availabilityService.dates.search({
      appointmentTypeID: this.appointment.appointmentType.acuityId,
      month: moment().add(3, 'month').format("YYYY-MM"),
      organization: this.practice.code,
      user: this.provider.user.id,
      category: this.category ? this.category.id : '',
      timeZone: this.timeZone
    }).subscribe(page => {
      if (!this.availableDates) {
        this.availableDates = []
      }
      for (const item of page.items) {
        this.availableDates.push(new AvailableDate(item))
      }
    })
    this.availabilityService.dates.search({
      appointmentTypeID: this.appointment.appointmentType.acuityId,
      month: moment().add(4, 'month').format("YYYY-MM"),
      organization: this.practice.code,
      user: this.provider.user.id,
      category: this.category ? this.category.id : '',
      timeZone: this.timeZone
    }).subscribe(page => {
      if (!this.availableDates) {
        this.availableDates = []
      }
      for (const item of page.items) {
        this.availableDates.push(new AvailableDate(item))
      }
    })
    this.availabilityService.dates.search({
      appointmentTypeID: this.appointment.appointmentType.acuityId,
      month: moment().add(5, 'month').format("YYYY-MM"),
      organization: this.practice.code,
      user: this.provider.user.id,
      category: this.category ? this.category.id : '',
      timeZone: this.timeZone
    }).subscribe(page => {
      if (!this.availableDates) {
        this.availableDates = []
      }
      for (const item of page.items) {
        this.availableDates.push(new AvailableDate(item))
      }
    })
    this.availabilityService.dates.search({
      appointmentTypeID: this.appointment.appointmentType.acuityId,
      month: moment().add(6, 'month').format("YYYY-MM"),
      organization: this.practice.code,
      user: this.provider.user.id,
      category: this.category ? this.category.id : '',
      timeZone: this.timeZone
    }).subscribe(page => {
      if (!this.availableDates) {
        this.availableDates = []
      }
      for (const item of page.items) {
        this.availableDates.push(new AvailableDate(item))
      }
    })
  }

  timeZoneChange() {
    if (this.practice && this.practice.code && this.appointment.appointmentType && this.appointment.appointmentType.acuityId) {
      this.selectedTime = null
      this.availableTimes = []
      this.availableSlots = 1
      this.appointment.visitors = []
      this.availableDates = null
      this.getDates()
    }
  }

  setClass() {
    return (date: any) => {
      if (date) {
        date = moment(date).toDate()
        if (date.getDate() == 1) this.changeMonth(
          {
            month: date.getMonth() + 1,
            year: date.getFullYear()
          });
      }
    };
  }

  getCalendar(provider, calendarID): { calendar: Calendar, category: Category } {
    let data
    for (const item of provider.calendars) {
      if (item.calendar.acuityId == calendarID) {
        data = {
          calendar: item.calendar,
          category: item.category
        }
      }
    }
    return data
  }

  changeMonth(date) {
    console.log(date)
  }

  onDateUpdate($event) {
    this.selectedTime = null
    this.availableTimes = []
    this.date = $event.value
    this.availableSlots = 1
    this.appointment.visitors = []
    this.availabilityService.slots.search({
      appointmentTypeID: this.appointment.appointmentType.acuityId,
      date: moment($event.value).format("YYYY-MM-DD"),
      organization: this.practice.code,
      category: this.category ? this.category.id : '',
      user: this.provider.user.id,
      timeZone: this.timeZone
    }).subscribe(page => {
      this.availableTimes = []
      for (const item of page.items) {
        this.availableTimes.push(new AvailableTime(item, this.timeZone))
      }
      if (this.availableTimes.length == 0) {
        this.errorHandler.handleError("Not timeslot found for select Date and Appointment")
      }
    })
  }

  displayPrescriber(item?: Practitioner): string | undefined {
    if (!item) {
      return "";
    }

    if (typeof item === "string") {
      return item;
    }

    if (!item.profile) {
      return item.code;
    }
    return `${item.prefix} ${item.profile.firstName} ${item.profile.lastName}`;
  }

  onProviderSelected() {
    this.isProcessing = true
    this.availableDates = null
    this.selectedTime = null
    this.date = null
    this.availableTimes = []
    this.availableSlots = 1
    this.appointment.visitors = []
    this.appointment.appointmentType = null
    this.appointmentTypeService.search({
      organization: this.practice.code,
      user: this.provider.user.id,
      category: this.category ? this.category.id : '',
    }).subscribe(page => {
      this.appointmentTypes = page.items
      this.isProcessing = false
    }, err => {
      this.isProcessing = false
    })
  }

  onBulkAdd(): void {
    const dialogRef = this.dialog.open(AddPatientsDialogComponent);
    if (this.appointment.visitors) {
      let patients: Patient[] = []
      this.appointment.visitors.forEach(item => {
        let newPatient = new Patient(item.user)
        newPatient.practiceLocation = item.user.meta.division
        // newPatient.practitioner = item.user.meta.prescriber
        newPatient.practice = item.user.meta.organization
        patients.push(newPatient)
      })
      dialogRef.componentInstance.patients = patients
      dialogRef.componentInstance.availableSlots = this.availableSlots
    }
    dialogRef.afterClosed().subscribe((data) => {
      if (data && data.isSuccess) {
        this.appointment.visitors = []
        if (data.patients && data.patients.length) {
          data.patients.forEach(patient => {
            let meta = {
              division: patient.practiceLocation,
              providers: patient.practitioners,
              organization: patient.practice
            }
            let newUser = new User({
              role: patient.role,
              profile: patient.profile,
              meta: meta
            })
            if (patient.profile && patient.profile.middleName) {
              newUser.profile.lastName = patient.profile.middleName + " " + newUser.profile.lastName
            }
            if (patient.profile && patient.profile.prefix) {
              newUser.profile.title = patient.profile.prefix
            }
            this.appointment.visitors.push({ user: newUser })
            this.availableSlots--
          });
        }
      }
    });
  }

  quickAddUser() {
    const dialogRef = this.dialog.open(QuickAddPatientsDialogComponent);
    dialogRef.afterClosed().subscribe((data) => {
      if (data && data.isSuccess) {
        if (data.patient) {
          let visitors = []
          for (const visitor of this.appointment.visitors) {
            visitors.push(visitor)
          }
          this.appointment.visitors = []
          let exists = false
          for (const visitor of visitors) {
            if (visitor.user.role.id == data.patient.role.id) {
              exists = true
            }
          }
          if (!exists) {
            let meta = {
              division: data.patient.practiceLocation,
              providers: data.patient.practitioners,
              organization: data.patient.practice
            }
            let newUser = new User({
              role: data.patient.role,
              profile: data.patient.profile,
              meta: meta
            })
            if (data.patient.profile && data.patient.profile.middleName) {
              newUser.profile.lastName = data.patient.profile.middleName + " " + newUser.profile.lastName
            }
            if (data.patient.profile && data.patient.profile.prefix) {
              newUser.profile.title = data.patient.profile.prefix
            }
            visitors.push({ user: newUser })
          }
          this.appointment.visitors = visitors
          this.availableSlots--
        }
      }
    });
  }

  removePatient(patient: any) {
    let arr = []
    for (const visitor of this.appointment.visitors) {
      if (visitor.user.role.id != patient.user.role.id) {
        arr.push(visitor)
      }
    }
    this.appointment.visitors = arr;
    this.availableSlots++
  }

  onSelectedTime($event) {
    this.availableSlots = this.selectedTime.slotsAvailable
    this.appointment.from = this.selectedTime.time
    this.appointment.visitors = []
  }

  reset() {
    this.practice = null
    this.availableTimes = []
    this.selectedTime = null
    this.date = null
    this.appointment.appointmentType = null
    this.availableSlots = 1
    this.appointment.visitors = []
    this.appointment.from = null
  }

  dateFilter(d: Date) {
    if (this.availableDates) {
      let found = false
      for (const availableDate of this.availableDates) {
        if (availableDate.date == moment(d).format('YYYY-MM-DD')) {
          found = true
        }
      }
      return found
    } else {
      return true
    }
  };

  getCategories() {
    for (const user of this.practice.users) {
      for (const calendar of user.calendars) {
        if (calendar.isActive) {
          if (!this.isCategoryExists(this.categories, calendar.category)) {
            this.categories.push(calendar.category)
          }
        }
      }
    }
  }

  onCategorySelected() {
    this.providers = []
    for (const user of this.practice.users) {
      for (const calendar of user.calendars) {
        if (calendar.isActive && this.category.id == calendar.category.id) {
          let index = this.getProviderIndex(this.providers, user.user)
          if (index >= 0) {
            this.providers[index].calendars.push(calendar)
          } else {
            this.providers.push({
              user: user.user,
              calendars: [calendar]
            })
          }
        }
      }
    }
    if (this.providers.length == 1) {
      this.provider = this.providers[0]
      this.onProviderSelected()
    }
  }

  isCategoryExists(categories, category): boolean {
    let exists = false
    for (const item of categories) {
      if (item.id == category.id) {
        exists = true
      }
    }
    return exists
  }

  getProviderIndex(providers, provider) {
    let index
    providers.forEach((item, i) => {
      if (item.user.id == provider.id) {
        index = i
      }
    });
    return index
  }

}
